const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "53.300018310546875 615.3999633789062 647.60009765625 319.60003662109375",
    width: 647.60009765625,
    height: 319.60003662109375,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 700.600012 793.200012 A 9.4 17.799999 0 0 1 691.200012 811.000011 A 9.4 17.799999 0 0 1 681.800013 793.200012 A 9.4 17.799999 0 0 1 691.200012 775.400013 A 9.4 17.799999 0 0 1 700.600012 793.200012 Z",
    className: "st2",
    style: {
      fill: "rgb(204, 204, 204)",
      opacity: 1
    },
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 691.2999877929688 775.2999877929688 L 675.5 775.2999877929688 L 675.5 767.9000244140625 L 700.9000244140625 767.9000244140625 Z",
    className: "st3",
    style: {
      fill: "rgb(204, 204, 204)",
      opacity: 1
    },
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 684 767.900024 H 693.5 V 815.900024 H 684 V 767.900024 Z",
    className: "st3",
    style: {
      fill: "rgb(204, 204, 204)",
      opacity: 1
    },
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M514.8,883.9c0,28.2,22.9,51.1,51.1,51.1c28.2,0,51.1-22.9,51.1-51.1c0-28.2-22.9-51.1-51.1-51.1 C537.6,832.8,514.8,855.7,514.8,883.9",
    style: {
      fill: "rgb(204, 204, 204)",
      opacity: 1
    },
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M104.3,839.9h-51l16.1,21.5h33.9C103.2,861.4,95.8,851.8,104.3,839.9",
    style: {
      fill: "rgb(204, 204, 204)",
      opacity: 1
    },
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M672,738.3c0,0-70.3-9.2-77.4-13.5c-7.1-4.3-35.3-109.4-59.5-109.4c-24.1,0-417.8,0-417.8,0h-12.8 c0,0-12.8,0.7-12.8,10.7v245c0,0,1.4,12.8,19.9,12.8h18.2c0-38.1,30.9-69,69.1-69c38.1,0,69.1,30.9,69.1,69h228.8 c0-38.1,30.9-69,69.1-69c38.1,0,69.1,30.9,69.1,69h34.2c0,0,18.5,1.4,18.5-15.6V749.7C687.6,749.7,685.5,739.7,672,738.3z",
    style: {
      fill: "rgb(204, 204, 204)",
      opacity: 1
    },
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M147.8,883.9c0,28.2,22.9,51.1,51.1,51.1c28.2,0,51.1-22.9,51.1-51.1c0-28.2-22.9-51.1-51.1-51.1 C170.7,832.8,147.8,855.7,147.8,883.9",
    style: {
      fill: "rgb(204, 204, 204)",
      opacity: 1
    },
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 82.5 799.200012 H 91.8 V 827.100012 H 82.5 V 799.200012 Z",
    className: "st9",
    style: {
      fill: "rgb(204, 204, 204)",
      opacity: 1
    },
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.8f535b935bfc7764aa0b34515ab90e99.svg";
export { ForwardRef as ReactComponent };